import { Box, Tooltip, IconButton, Avatar } from "@mui/material";
import AttachmentIconnew from "../../assets/action-items/icon-attachment.svg";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { PRIORITY_OPTIONS, validateDate } from "../../utils/utils";
import dayjs from "dayjs";
import { useState, useEffect, useRef } from "react";
import ActionItemsAiIcon from "../../assets/interaction-detail-page/actionitems_ai-icon.svg";
import calendarIcon from "../../assets/interaction-detail-page/calendar-icon.svg";
import "../../styles/interactionDetailsPage.css";
import "../../styles/actionItems.css";
import ActionItemsAssigneeCell from "../ActionItems/ActionItemsAssigneeCell";
import ActionItemsStatusCell from "../ActionItems/ActionItemsStatusCell";
import SubscribedIcon from "../../assets/common/subscribedIcon.svg";
import ApproveIcon from "../../assets/approve.svg";
import DiscardIcon from "../../assets/discard.svg";
import PrioritySelector from "../ActionItems/PrioritySelector";
import "../../styles/interactionDetailsPage.css";

import ManualIcon from "../../assets/action-items/manual-icon.svg";
import EllipsedTooltip from "../Common/EllipsedTooltip";
import FeedBackIcon from "../../assets/common/action-items-feedback-icon.svg";
import OpenTaskIcon from "../../assets/common/Open-task-icon.svg";
import CloseTaskIcon from "../../assets/common/Close-task-icon.svg";
import SubTaskIcon from "../../assets/action-items/sub-tasks-icon.svg";
import SubTaskCountIcon from "../../assets/action-items/SubtaskCountIcon.svg";
import { resolveIsSubTaskFlag } from "../../utils/subtaskUtils";

const initialSort = { sort_field: "revised_due_date", sort_order: "asc" };
const initialFilter = [
  {
    id: "status",
    value: ["Not Started", "In Progress"],
  },
];

const getColumns = (
  _isLargeUp: boolean,
  rowAction?: any,
  highlightedCells?: Record<string, any>,
  removeHighlight?: any,
  isImpersonating?: boolean,
) => {
  const optimisticStatusMap = new Map<string, "approved" | "discarded">();
  const checkActionItemPermissions = (row: any) => {
    const isDiscarded =
      row.original?.isDiscarded ?? row?.isDiscarded ?? false;

    if (isDiscarded) {
      return { canEdit: false };
    }
    //  Use backend flag for Tasks table (isTask = true)
    const canEditTask = row.original?.canEdit ?? false;
    const canEdit = canEditTask && !isImpersonating;
    return { canEdit };
  };
  return [
    {
      accessorKey: "description",
      header: "Title",
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        const { canEdit } = checkActionItemPermissions( row);
        const isAiGenerated = row.original?.is_ai_generated;
        const isDeleted = row.original?.isDiscarded;
        const isSubTask = resolveIsSubTaskFlag(row.original);
        const subTaskCount = row.original?.subRows?.length ?? row.original?.subTasks?.length ?? 0;
        const hasSubTasks = subTaskCount > 0;
        const isExpanded = row.getIsExpanded();
        const parentRow = typeof row.getParentRow === "function" ? row.getParentRow() : null;
        const siblingRows = parentRow?.subRows ?? [];
        const isLastSubTask =
          isSubTask &&
          siblingRows.length > 0 &&
          siblingRows[siblingRows.length - 1]?.id === row.id;
        const treeCellClass = [
          "task-tree-title-cell",
          "flex flex-row justify-start items-center gap-2",
          isSubTask ? "task-tree-title-cell--child" : "",
          hasSubTasks && isExpanded ? "task-tree-title-cell--parent-expanded" : "",
          isLastSubTask ? "task-tree-title-cell--last-child" : "",
        ]
          .filter(Boolean)
          .join(" ");
        const handleOpenSlideover = (e?: React.MouseEvent) => {
          if (e) e.stopPropagation();
          if (isDeleted) return;
          const updatedRow = {
            ...row,
            original: {
              ...row.original,
              isSubTask: Boolean(isSubTask),
            },
          };
          rowAction.selectRowCallback(updatedRow, canEdit, Boolean(isSubTask));
        };

        return (
          <Box
            className={treeCellClass}
            sx={{
              paddingLeft: row.depth > 1 ? `${(row.depth - 1) * 16}px` : 0,
              width: "100%",
              minWidth: 0,
              maxWidth: "100%",
            }}
          >
            <div className="action-item-icons">
              {(hasSubTasks || isSubTask) && (
              <div className="task-tree-gutter">
                {isSubTask && (
                  <svg
                    className="task-tree-elbow"
                    viewBox="0 0 20 40"
                    fill="none"
                    aria-hidden
                    preserveAspectRatio="none"
                  >
                    {isLastSubTask ? (
                      <path d="M10 0 V12 Q10 20 18 20 H20" />
                    ) : (
                      <>
                        <path d="M10 0 V40" />
                        <path d="M10 12 Q10 20 18 20 H20" />
                      </>
                    )}
                  </svg>
                )}
                {hasSubTasks && isExpanded && !isSubTask && (
                  <span className="task-tree-stem" aria-hidden />
                )}
                {hasSubTasks && (
                  <button
                    type="button"
                    className={`task-tree-chevron ${
                      isExpanded ? "task-tree-chevron-expanded" : "task-tree-chevron-collapsed"
                    }`}
                    aria-label={isExpanded ? "Collapse subtasks" : "Expand subtasks"}
                    aria-expanded={isExpanded}
                    onClick={(e) => {
                      e.stopPropagation();
                      row.toggleExpanded();
                    }}
                  >
                    <img
                      src={isExpanded ? CloseTaskIcon : OpenTaskIcon}
                      alt=""
                    />
                  </button>
                )}
              </div>
              )}
              {isSubTask && (
                <img
                  src={SubTaskIcon}
                  alt="subtask"
                  className="action-item-subtask-icon"
                />
              )}
              <img
                src={isAiGenerated ? ActionItemsAiIcon : ManualIcon}
                alt={isAiGenerated ? "AI" : "Manual"}
                className="action-item-source-icon"
              />
            </div>
            <div
              className="truncate-table-cell-ellipsis interaction-action-title-text"
              style={{
                textDecoration: "underline",
                textDecorationColor: "rgba(25, 118, 210, 0.4)",
                cursor: isDeleted ? "not-allowed":"pointer",
              }}
              onClick={handleOpenSlideover}
            >
                  <EllipsedTooltip className="hover-style" tooltipContent={cell.getValue() as string} maxWidth="100%">
                  {cell.getValue()}
                  </EllipsedTooltip>
            </div>
            {hasSubTasks && ( 
              <Tooltip
                title={`${subTaskCount} ${subTaskCount === 1 ? "Subtask" : "Subtasks"}`}
                placement="top"
                arrow
                classes={{
                  tooltip: "subTask-count-tooltip",
                  arrow: "subTask-count-tooltip-arrow",
                }}
              >
                <Box
                  component="button"
                  type="button"
                  className="action-item-subtask-count"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenSlideover(e);
                  }}
                >
                  <img src={SubTaskCountIcon} alt="Subtasks" />
                  <span>{subTaskCount}</span>
                </Box>
              </Tooltip>
            )}
            {row.original.attachments?.length > 0 && (
              <img src={AttachmentIconnew} alt="" width={16} />
            )}
          </Box>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 500,
      maxSize: 600,
      size: 500,
    },
    {
      accessorKey: "assignee",
      header: "Solo Player",
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        const email = cell.getValue() as string;
        const assigneeName = row.original?.assignee_name;
        const { canEdit } = checkActionItemPermissions(row);
        const activeUsers = row?.original?.activeUsers;
        const assigneeParticipant = activeUsers?.find((u: any) => u.email === email)
        return (
          <ActionItemsAssigneeCell
            email={email}
            name={assigneeName}
            participant={assigneeParticipant}
            attendeeParticipants={activeUsers}
            canEdit={canEdit}
            row={row}
            rowAction={rowAction}
            highlightedCell={highlightedCells?.[row.id]?.assignee}
            autoOpenAssigneeDropdown={highlightedCells?.[row.id]?.open_assignee}
            removeHighlight={() => removeHighlight(row.id, "assignee")}
          />
        );
      },
      muiTableBodyCellProps: () => ({ className: "assignee-table-cell" }),
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 100,
      size: 100,
    },
    {
      accessorKey: "dueDate",
      header: "Due date",
      filterVariant: "date",
      filterFn: "lessThan",
      sortingFn: "datetime",
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        const [isDatePickerOpen, setDatePickerOpen] = useState(false);
        const value = cell.getValue() && dayjs(cell.getValue());
        const { canEdit } = checkActionItemPermissions(row);
        const cellRef = useRef<HTMLDivElement | null>(null);

        const handleDateClick = () => {
          if (canEdit) setDatePickerOpen(true);
        };

        const handleDateChange = (value: any) => {
          const formatted = value ? dayjs(value).format("YYYY-MM-DD") : value;
          rowAction.updateDueDateCallback(row, formatted);
          setDatePickerOpen(false);
        };

   useEffect(() => {
    if (
      highlightedCells?.[row.id]?.autoOpenDueDatePicker &&
      canEdit &&
      !isDatePickerOpen
    ) {
      const timer = setTimeout(() => {
        setDatePickerOpen(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [highlightedCells, row.id, canEdit]);

    useEffect(() => {
      if (!highlightedCells?.[row.id]?.dueDate) return;

      const handleClickOutside = (e: MouseEvent) => {
        if (cellRef.current && !cellRef.current.contains(e.target as Node)) {
          removeHighlight(row.id, "dueDate");
          removeHighlight(row.id, "autoOpenDueDatePicker");
        }
      };
    
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [highlightedCells, row.id]);

        return (
          <>
            <Box
            ref={cellRef}
            className={`due-date-cell-wrapper ${
              isDatePickerOpen ? "due-date-cell-wrapper--active" : ""
            } ${highlightedCells?.[row.id]?.dueDate ? "error-border" : ""} ${ !canEdit ? "no-hover" : ""
            }`}
            >
              {canEdit ? (
                <>
                  {isDatePickerOpen ? (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        open={isDatePickerOpen}
                        onClose={() => setDatePickerOpen(false)}
                        value={value}
                        format="MMM DD YYYY"
                        onChange={handleDateChange}
                        components={{ OpenPickerIcon: () => null }}
                        className="action-item-datepicker"
                      />
                    </LocalizationProvider>
                  ) : (
                    <>
                      {value ? (
                        <span
                          onClick={handleDateClick}
                          style={{ cursor: "pointer" }}
                        >
                          {validateDate(cell.getValue(), "MMM DD YYYY")}
                        </span>
                      ) : (
                        <Tooltip title="Set Due Date" arrow placement="top">
                          <IconButton
                            onClick={handleDateClick}
                            size="small"
                            className="action-item-calendar-icon"
                          >
                            <img
                              src={calendarIcon}
                              alt="Calendar"
                              width={18}
                              height={18}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                    </>
                  )}
                </>
              ) : (
                <span>{validateDate(cell.getValue(), " MMM DD YYYY")}</span>
              )}
            </Box>
          </>
        );
      },
      muiTableBodyCellProps: () => ({
        className: "due-date-table-cell",
      }),

      enableColumnFilter: true,
      enableSorting: false,
      grow: true,
      minSize: 120,
      size: 120,
    },
    {
      accessorKey: "status",
      header: "Status",
      filterVariant: "multi-select",
      filterSelectOptions: ["Draft", "Todo", "InProgress", "Completed"],
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        const value = cell.getValue() as string;
        const { canEdit } = checkActionItemPermissions(row);
        const [isStatusOpen, setStatusOpen] = useState(false);

        return (
          <Box
            className={`priority-cell-wrapper ${
              isStatusOpen ? "priority-cell-wrapper--active" : ""
            } ${!canEdit ? "no-hover" : ""}`}
          >
            <ActionItemsStatusCell
              value={value}
              canEdit={canEdit}
              onOpen={() => setStatusOpen(true)}
              onClose={() => setStatusOpen(false)}
              onChange={function (newStatus: string) {
                rowAction.updateStatusCallback(row, newStatus);
              }}
            />
          </Box>
        );
      },
      muiTableBodyCellProps: () => ({
        className: "status-table-cell",
      }),
      enableColumnFilter: true,
      enableSorting: false,
      grow: true,
      minSize: 100,
      size: 100,
    },

    {
      accessorKey: "coachEmail", // keep this for table display (data key)
      header: "Solo Coach",
      Cell: ({ row }: { row: any }) => {
        const email = row.original.coachEmail; // still use coachEmail from API response
        const activeUsers = row?.original?.activeUsers;
        const { canEdit } = checkActionItemPermissions(row);
        const coachParticipant = activeUsers.find((u: any) => u.email === email);

        return (
          <ActionItemsAssigneeCell
            email={email}
            name={coachParticipant?.name || email}
            participant={coachParticipant}
            attendeeParticipants={activeUsers}
            canEdit={canEdit}
            row={row}
            rowAction={rowAction}
            fieldName="coach"
            onUpdate={(row: any, value: string | null) => {
              //  Always call updateCoachCallback — it will send payload with "coach"
              rowAction?.updateCoachCallback?.(row, value);

              //  (Optional fallback only if callback missing)
              if (!rowAction?.updateCoachCallback) {
                const { assignee, attachments, description, status, dueDate } =
                  row.original;
                const payload = {
                  coach: value, //  changed from coachEmail → coach
                  assignee,
                  attachments,
                  title: description,
                  status,
                  dueDate: dayjs(dueDate).utc().format(),
                };
                rowAction?.mutateActionItemUpdate?.(payload);
              }
            }}
          />
        );
      },
      muiTableBodyCellProps: () => ({ className: "coach-table-cell" }),
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 100,
      size: 100,
    },

    {
      accessorKey: "creator_name",
      header: "Assignor",
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        const email = row.original.creator_email;
        const name = cell.getValue() as string;
        const activeUsers = row?.original?.activeUsers;
        if (email === null || email === undefined) {
          return <span>-</span>;
        }
        const assignorParticipant = activeUsers.find(
          (p: any) => p.email === email
        );
        return (
          <Tooltip title={name} placement="top" arrow>
            <div>
              <Avatar
                src={assignorParticipant?.pictureUrl || undefined}
                alt={assignorParticipant?.name || name || email}
                sx={{ height: "33px", width: "33px" }}
              >
                {((assignorParticipant?.name || name || email) ?? "")
                  .split(" ")
                  .map((word: any) => word[0]?.toUpperCase())
                  .slice(0, 2)
                  .join("")}
              </Avatar>
            </div>
          </Tooltip>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 70,
      size: 70,
    },
    {
      accessorKey: "accept_discard",
      header: "Accept / Discard",
      enableColumnFilter: false,
      enableSorting: false,
      size: 150,
      grow: false,
      muiTableBodyCellProps: () => ({ sx: { overflow: "visible" } }),
      Cell: ({ row }: { row: any }) => {
        const { canEdit } = checkActionItemPermissions(row);
        const rowId = row.original?.id || row.id;
        const optimisticStatus = optimisticStatusMap.get(rowId) || null;
        const isBulkSelection = rowAction?.isBulkSelection;
        const isSubTask = resolveIsSubTaskFlag(row.original);

      const isApproved =
        optimisticStatus === "approved" || row.original?.isApproved;

      const isDiscarded =
        optimisticStatus === "discarded" || row.original?.isDiscarded;

        const isAiGenerated =
          row.original?.isAiGenerated ?? row.original?.is_ai_generated;
        // Added: handleApproveClick with validation logic
        const handleApproveClick = async () => {
          const assignee = row.original?.assignee;
          const dueDate = row.original?.dueDate;

          // Check if either field is missing
          if (!assignee || !dueDate) {
            // Highlight missing fields
            rowAction?.highlightMissingFields?.(row, {
              assignee: !assignee,
              open_assignee: !assignee,
              dueDate: !dueDate,
              autoOpenDueDatePicker: !dueDate && assignee, 
            });
            rowAction?.showSnackbar?.(
              "warning",
              "Please fill the missing fields to proceed with approval."
            );

            return;
          }
          optimisticStatusMap.set(rowId, "approved");
          const apiResult = await rowAction.acceptCallback(row);
          // Only update if API returns different from optimistic
          if (apiResult?.status && apiResult.status !== "approved") {
            optimisticStatusMap.delete(rowId);
          }
        };
        const handleDiscardClick = () => {
          rowAction.discardCallback(row);
        };

        if (isAiGenerated === false) {
          return (
            <Box className="accept-discard-status-box manual-box">
              <h1 className="base-text-status">Manual</h1>
            </Box>
          );
        }
        if (isApproved) {
          return (
            <Box className="accept-discard-status-box approve-box">
              <h1 className="base-text-status approve">Accepted</h1>
            </Box>
          );
        }

        if (isDiscarded) {
          const isFeedbackOpen = Boolean(
            row.original?.isDiscardFeedbackActive
          );
          return (
            <>
              <Box
                className={`accept-discard-status-box discard-box ${
                  isFeedbackOpen ? "discard-box--active" : "discard-box"
                }`}
              >
              <h1 className="base-text-status discard">Discarded</h1>
            </Box>
            {rowAction?.showFeedbackIcon !== false && (
                <Tooltip title="Give feedback" placement="top" arrow>
                  <IconButton
                    size="small"
                    className={`discard-feedback-btn ${
                      isFeedbackOpen ? "discard-feedback-btn--active" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      rowAction?.openDiscardFeedbackCallback?.(
                        row,
                        e.currentTarget
                      );
                    }}
                  >
                    <img
                      src={FeedBackIcon}
                      className={`discard-feedback-icon ${
                        isFeedbackOpen ? "discard-feedback-icon--active" : ""
                      }`}
                    />
                  </IconButton>
                </Tooltip>
              )}
            </>
          );
        }

        if (isSubTask) {
          return null;
        }

        // Case 3: Pending → show both buttons
        return (
          <Box className="accept-discard-buttons-box" sx={{
            opacity: isBulkSelection ? 0.35 : 1,
            pointerEvents: isBulkSelection ? "none" : "auto",
          }}>
            {/* Approve Button */}
            <Tooltip title="Accept" placement="top" arrow>
              <span>
                <IconButton
                  size="small"
                  disabled={!canEdit}
                  onClick={handleApproveClick}
                  className="approve-btn"
                >
                  <img
                    src={ApproveIcon}
                    alt="Approve"
                    className="approve-icon"
                    style={{ opacity: canEdit ? 1 : 0.5 }}
                  />
                </IconButton>
              </span>
            </Tooltip>

            {/* Discard Button */}
            <Tooltip title="Discard" placement="top" arrow>
              <span>
                <IconButton
                  size="small"
                  disabled={!canEdit}
                  onClick={handleDiscardClick}
                  className="discard-btn"
                >
                  <img
                    src={DiscardIcon}
                    alt="Discard"
                    className="discard-icon"
                    style={{ opacity: canEdit ? 1 : 0.5 }}
                  />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        );
      },
    },

    {
      accessorKey: "priority",
      header: "Priority",
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        const value = cell.getValue(); //  use actual backend value, no hardcode
        const { canEdit } = checkActionItemPermissions(row);
        const [activeDropdownId, setActiveDropdownId] = useState<string | null>(null);

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {canEdit ? (
              <PrioritySelector
                id="priority"
                activeDropdownId={activeDropdownId}
                setActiveDropdownId={setActiveDropdownId}
                value={value || ""}
                onChange={(newPriority) =>
                  rowAction.updatePriorityCallback(row, newPriority)
                }
                disabled={!canEdit}
                options={PRIORITY_OPTIONS}
                variant="icon"
              />
            ) : value ? (
              <PrioritySelector
                id="priority"
                activeDropdownId={activeDropdownId}
                setActiveDropdownId={setActiveDropdownId}
                value={value}
                onChange={() => {}}
                disabled={true}
                options={PRIORITY_OPTIONS}
                variant="icon"
              />
            ) : (
              //  No priority + not editable → show “-”
              <span style={{ color: "#9E9E9E" }}>-</span>
            )}
          </Box>
        );
      },
      muiTableBodyCellProps: () => ({ className: "priority-table-cell" }),
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 100,
      size: 100,
    },
    {
      accessorKey: "subscribe",
      header: "",
      enableColumnFilter: false,
      enableSorting: false,
      size: 50,
      grow: false,
      Cell: ({ row }: { row: any }) => {
        const isSubscribed = row.original?.isSubscribed;
        return (
          <Box className="subscribed-box">
            <Tooltip
              title={isSubscribed ? "Stop Tracking" : "Track"}
              arrow
              placement="top"
            >
              <IconButton
                size="small"
                onClick={() => rowAction.toggleSubscribeCallback(row)}
              >
                <img
                  src={SubscribedIcon}
                  alt={isSubscribed ? "Subscribe" : "Unsubscribe"}
                  style={{ width: 20, height: 20 }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];
};

export { getColumns, initialSort, initialFilter };
